var m;

m = require('mithril');

module.exports = {
  view: function() {
    return m('.NoAccount', [
      m('p', [
        'You are not currently logged in.', m('a[href="/login"]', {
          config: m.route
        }, 'Log in')
      ])
    ]);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9Ob0FjY291bnQuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9Ob0FjY291bnQuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsQ0FBQSxHQUFJLE9BQUEsQ0FBUSxTQUFSOztBQUVKLE1BQU0sQ0FBQyxPQUFQLEdBQWlCO0VBQ2hCLElBQUEsRUFBTSxTQUFBO1dBQ0wsQ0FBQSxDQUFFLFlBQUYsRUFBZ0I7TUFDZixDQUFBLENBQUUsR0FBRixFQUFPO1FBQ04sa0NBRE0sRUFFTixDQUFBLENBQUUsa0JBQUYsRUFBc0I7VUFBQyxNQUFBLEVBQVEsQ0FBQyxDQUFDLEtBQVg7U0FBdEIsRUFBeUMsUUFBekMsQ0FGTTtPQUFQLENBRGU7S0FBaEI7RUFESyxDQURVIn0=
